import './style/index.js';

import _Divider from './Divider';

export type { DividerProps } from './Divider';
export * from './type';

export const Divider = _Divider;
export default Divider;
